<template>
  <div>
    <!-- :width="isCheckbox ? Number(width) + 55 : width"  -->
    <el-popover
      :width="isCheckbox ? Number(width) + 55 : width"
      placement="bottom-start"
      trigger="focus"
      ref="popover"
      @after-leave="hide">
      <div class="table" v-loading="loading">
        <u-table
          :data="tableList"
          :border="false"
          size="small"
          stripe
          ref="table"
          @row-click="rowClick"
          @select="handleSelectionChange"
          style="width: 100%"
        >
          <template slot="empty"> 没有查询到符合条件的记录 </template>
          <u-table-column v-if="isCheckbox" type="selection" width="55"></u-table-column>
          <slot>
            <u-table-column prop="itemName" label="商品" width="180"></u-table-column>
          </slot>
          <!-- <u-table-column prop="itemName" label="商品" width="180"></u-table-column>
          <u-table-column prop="itemSpec" label="规格" width="100"> </u-table-column>
          <u-table-column prop="availableQtyFormat" label="可用库存" width="100"> </u-table-column>
          <u-table-column prop="productionDate" label="生产日期" width="100" v-if="power.isEnableProductDate == 'Y'"></u-table-column>
          <u-table-column prop="flavor" label="多口味" width="140">
            <template slot-scope="{ row }">
              <el-select v-if="row.flavorList" v-model="row.flavor" placeholder="请选择多口味" value-key="flavorID" size="mini" @change="flavorChange(row)">
                <el-option
                  v-for="item in row.flavorList"
                  :key="item.flavorID"
                  :label="item.flavorDesc"
                  :value="item">
                </el-option>
              </el-select>
            </template>
          </u-table-column> -->
        </u-table>
        <el-pagination class="pagination" size="mini" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" :layout="pageLayout" :total="total"></el-pagination>
      </div>
      <el-input
        ref="referenceInput"
        :placeholder="row.itemName ? row.itemName : '请输入商品名称'"
        v-model="select"
        slot="reference"
        @keydown.native="handleSelect"
        @input="inputInput"
        clearable>
      </el-input>
    </el-popover>
  </div>
</template>

<script>
import { debounce } from '@/assets/js/common.js'
export default {
  props: {
    parameter: {
      type: Object,
      default: () => {}
    },
    url: {
      type: String,
      default: '/Account/dataSearchVue/selectItemEnterDetailList.html'
    },
    width: {
      type: String,
      default: '430'
    },
    isCheckbox: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {
        return {
          itemName: '请输入商品名称'
        }
      }
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").onfocus = function (e) {
          e.currentTarget.select();
        };
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    return {
      select: '',
      selectRow: {},
      tableList: [],
      params: {
        page: 1,
        size: 5,
        keyWords: '',
        ...this.parameter
      },
      loading: false,
      total: 0,
      power: {},
      source: null,
      selectIndex: 0
    };
  },
  watch: {
    '$store.state.power'(val) {
      this.power = val
    }
  },
  created() {
    this.getTableList()
    this.power = this.$store.state.power
  },
  mounted() {
    this.$refs.referenceInput.focus()
  },
  computed: {
    pageLayout() {
      // if (this.width <= 300) {
      //   return 'total, jumper'
      // } else if (this.width <= 430) {
      //   return 'total, pager, jumper'
      // } else {
        return 'total, pager, jumper'
      // }
    }
  },
  methods: {
    getTableList() {
      this.loading = true
      const CancelToken = this.$http.CancelToken;
      const source = CancelToken.source();
      if (this.source) {
        this.source.cancel()
      }
      this.$http.post(this.url, this.Qs.stringify(this.params), {
        cancelToken: source.token
      }).then(({ data: res }) => {
        this.loading = false
        if (res.code == 'success') {
          let { data, total } = JSON.parse(res.result)
          this.tableList = JSON.parse(data)
          this.total = total
          this.$nextTick(() => {
            this.$refs.popover.updatePopper()
            if (this.row.itemName) {
              let index = this.tableList.findIndex(i => i.itemName == this.row.itemName)
              if (index > -1) this.selectIndex = index
            } else {
              this.selectIndex = 0
            }
            try {
              this.$refs.table.setCurrentRow(this.tableList[this.selectIndex])
            } catch (error) {
              
            }
          })
        }
      })
      this.source = source
    },
    rowClick(row) {
      this.selectRow = row
      this.$emit('select', row)
    },
    selectClear() {
      this.params.keyWords = ''
      this.selectRow = {}
      this.getTableList()
    },
    remoteMethod(query) {
      this.select = query
      this.params.keyWords = query
      this.params.page = 1
      this.getTableList()
    },
    handleSizeChange(newSize) {
      this.params.size = newSize
      this.getTableList()
    },
    // 翻页
    handleCurrentChange(newPage) {
      this.params.page = newPage
      this.getTableList()
    },
    flavorChange(row) {
      this.$emit('select', row)
    },
    handleSelectionChange(selection, row) {
      console.log(row)
      this.$emit('select', [row])
    },
    hide() {
      this.$emit('hide')
    },
    handleSelect({ code }) {
      if (code == 'ArrowUp') {
        if (this.selectIndex) {
          this.selectIndex -= 1
          this.$refs.table.setCurrentRow(this.tableList[this.selectIndex])
        } else {
          this.selectIndex = this.tableList.length - 1
          this.$refs.table.setCurrentRow(this.tableList[this.selectIndex])
        }
      } else if (code == 'ArrowDown') {
        if (this.selectIndex != this.tableList.length) {
          this.selectIndex += 1
          if (this.selectIndex >= this.tableList.length) {
            this.selectIndex = 0
          }
          this.$refs.table.setCurrentRow(this.tableList[this.selectIndex])
        }
      } else if (code == 'NumpadEnter' || code == 'Enter') {
        this.$emit('select', this.tableList[this.selectIndex])
      }
    },
    inputInput: debounce(function (val) {
      this.params.keyWords = val
      this.params.page = 1
      this.getTableList()
    }, 300)
  },
};
</script>

<style scoped lang="less">
::v-deep .el-table {
  .el-table__header-wrapper  .el-checkbox{ //把表头里面的复选框隐藏掉
    display:none
  }
}
.selectByProduct {

  .el-select-dropdown__item {
    padding: 0;
    height: auto;
    line-height: normal;
  }
}
</style>